import routes from './routes';
import { SetRoutes } from 'components';

const ExtraSalesPages = () => {
  return (
    <>
      <SetRoutes routes={routes} />
    </>
  );
};

export default ExtraSalesPages;
